import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import { createUnknownComponentVNode as _$cc, className as _$cn, createElementVNode as _$ce, superCall as _$su, extend as _$ex, EMPTY_OBJ as _$em, map as _$ma } from 'intact-vue-next';
import { Dropdown, DropdownMenu, DropdownItem } from '../dropdown';
import { Icon } from '../icon';
import { _$ } from '../../i18n';
import { makeMenuStyles, makeFilterMenuStyles } from './styles';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    data = _this$get.data,
    trigger = _this$get.trigger,
    filterable = _this$get.filterable,
    fields = _this$get.fields,
    multiple = _this$get.multiple,
    show = _this$get.show;
  var k = this.config.k;
  var baseMenuStyles = makeMenuStyles(k);
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-cascader-menu"] = true, _classNameObj[makeMenuStyles(k)] = true, _classNameObj);
  var getField = this.fields;
  var _this$value = this.value,
    values = _valuesInstanceProperty(_this$value),
    isShowed = _this$value.isShowed,
    isSelected = _this$value.isSelected,
    onSelect = _this$value.onSelect,
    toggleShowedValue = _this$value.toggleShowedValue;
  var Options = function Options(data, level, loaded, parentSelected) {
    if (!data.length) {
      if (!loaded) {
        return _$cc(Icon, {
          'className': _$cn("ion-load-c " + k + "-cascader-loading"),
          'rotate': true
        });
      } else {
        return _$ce(2, 'div', _$('无数据'), 0, _$cn(k + "-cascader-empty"));
      }
    }
    return _mapInstanceProperty(data).call(data, function (item, index) {
      var value = getField(item, 'value');
      var showed = show && isShowed(value, level);
      var selected = parentSelected && isSelected(value, level);
      var children = getField(item, 'children');
      var Item = function Item() {
        var _$cn2;
        return _$cc(DropdownItem, {
          'disabled': getField(item, 'disabled'),
          'className': _$cn((_$cn2 = {}, _$cn2[k + "-cascader-option"] = true, _$cn2[k + "-active"] = showed, _$cn2[k + "-selected"] = selected, _$cn2)),
          'ev-select': onSelect.bind(null, value, level),
          'hideOnSelect': !multiple,
          'children': [getField(item, 'label'), children ? _$cc(Icon, {
            'className': _$cn(k + "-cascader-arrow " + k + "-icon-right")
          }) : undefined]
        });
      };
      return children ? _$cc(Dropdown, {
        'position': _this.positionObj,
        'of': 'parent',
        'disabled': getField(item, 'disabled'),
        'trigger': trigger,
        'value': showed,
        'ev-$change:value': toggleShowedValue.bind(null, value, level),
        'ev-show': _this.load.bind(null, item),
        'children': [Item(), _$cc(DropdownMenu, {
          'className': _$cn(classNameObj),
          'children': showed ? Options(children, level + 1, item.loaded, selected) : null
        })]
      }) : Item();
    });
  };
  var _this$filterable = this.filterable,
    filter = _filterInstanceProperty(_this$filterable),
    keywords = _this$filterable.keywords.value,
    selectByFilter = _this$filterable.selectByFilter,
    isSelectedItem = _this$filterable.isSelectedItem;
  return _$su.call($this, {
    'className': _$cn(k + "-cascader")
  }, function ($blocks) {
    var _$blocks = {},
      __$blocks = _$ex({}, $blocks);
    return (_$blocks['base-menu'] = function ($super) {
      var _$cn3;
      return !filterable || !keywords ? _$cc(DropdownMenu, {
        'className': _$cn(classNameObj),
        'key': 'common',
        'children': Options(data, 0, true, true)
      }, 'common') : _$cc(DropdownMenu, {
        'key': 'filter',
        'className': _$cn((_$cn3 = {}, _$cn3[k + "-cascader-filter"] = true, _$cn3[baseMenuStyles] = true, _$cn3[makeFilterMenuStyles(k)] = true, _$cn3)),
        'children': function () {
          var items = filter();
          if (!items.length) return _$ce(2, 'div', _$('无匹配数据'), 0, _$cn(k + "-cascader-empty"));
          return _$ma(items, function ($value, $key) {
            var _$cn4;
            return _$cc(DropdownItem, {
              'ev-select': selectByFilter.bind(null, $value),
              'disabled': $value.disabled,
              'hideOnSelect': !multiple,
              'className': _$cn((_$cn4 = {}, _$cn4[k + "-selected"] = isSelectedItem($value), _$cn4)),
              'children': function () {
                // highlight keywords
                var label = _mapInstanceProperty($value).call($value, function (item) {
                  return getField(item, 'label');
                }).join(' / ');
                var labels = label.split(keywords);
                var length = labels.length;
                return _mapInstanceProperty(labels).call(labels, function (item, index) {
                  var ret = [item];
                  if (index !== length - 1) {
                    ret.push(_$ce(2, 'em', keywords, 0));
                  }
                  return ret;
                });
              }()
            });
          }, $this);
        }()
      }, 'filter');
    }, __$blocks['base-menu'] = function ($super, data) {
      var block = $blocks['base-menu'];
      var callBlock = function callBlock() {
        return _$blocks['base-menu'].call($this, $super, data);
      };
      return block ? block.call($this, callBlock, data) : callBlock();
    }), __$blocks;
  }.call($this, $blocks), $__proto__);
}
;